module.exports = __webpack_public_path__ + "img/utra_mujeres.7a8cbe6b.jpg";